import { template as template_b7f4f5d03ee547e88840f7db4b4351a8 } from "@ember/template-compiler";
import { action } from '@ember/object';
import Component from '@glimmer/component';
/**
  Renders a `<tbody>` element and yields the row component, row data and index.
  ```hbs
  <table.body as |body person index|>
    <body.row as |row|>
      <row.cell>
        {{person.firstName}} #{{index}}
      </row.cell>
      <row.cell>
        {{person.lastName}}
      </row.cell>
      <row.cell>
        {{person.points}}
      </row.cell>
    </body.row>
  </table.body>
  ```
  It can also be used as a blockless component to let yeti table automatically
  unroll thee rows for you, based on the `@prop` arguments you passed in to the
  column definition components.
  ```hbs
  <table.body/>
  ```
  Remember that this component's block will be rendered once per each item in the `@data` array.

  @class Body
  @yield {object} body
  @yield {Component} body.row - the row component
  @yield {Object} rowData - one item in the data array
  @yield {number} index
*/ // template imports
import { fn, get, hash } from '@ember/helper';
import TBodyRow from './tbody/row.gjs';
export default class Body extends Component {
    static{
        template_b7f4f5d03ee547e88840f7db4b4351a8(`
    <tbody class={{@theme.tbody}} ...attributes>
      {{#if (has-block)}}

        {{#each @data as |rowData index|}}
          {{yield (hash row=(component TBodyRow theme=@theme onClick=@onRowClick columns=@columns)) rowData index}}
        {{/each}}

      {{else}}

        {{#each @data as |rowData|}}
          <TBodyRow
            @theme={{@theme}}
            @onClick={{if @onRowClick (fn this.handleRowClick rowData)}}
            @columns={{@columns}}
            as |row|
          >

            {{#each @columns as |column|}}
              <row.cell @class={{column.columnClass}}>
                {{#if column.prop}}
                  {{get rowData column.prop}}
                {{else}}
                  {{rowData}}
                {{/if}}
              </row.cell>
            {{/each}}
          </TBodyRow>
        {{/each}}
      {{/if}}
    </tbody>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
    /**
   * Adds a click action to each row, called with the clicked row's data as an argument.
   * Can be used with both the blockless and block invocations.
   *
   * @argument onRowClick
   * @type Function
   */ @action
    handleRowClick(rowData) {
        this.args.onRowClick?.(rowData);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9taWd1ZWwvd29ya3NwYWNlL2VtYmVyLXlldGktdGFibGUvZW1iZXIteWV0aS10YWJsZS9zcmMvY29tcG9uZW50cy95ZXRpLXRhYmxlL2JvZHkuZ2pzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGFjdGlvbiB9IGZyb20gJ0BlbWJlci9vYmplY3QnO1xuXG5pbXBvcnQgQ29tcG9uZW50IGZyb20gJ0BnbGltbWVyL2NvbXBvbmVudCc7XG5cbi8qKlxuICBSZW5kZXJzIGEgYDx0Ym9keT5gIGVsZW1lbnQgYW5kIHlpZWxkcyB0aGUgcm93IGNvbXBvbmVudCwgcm93IGRhdGEgYW5kIGluZGV4LlxuICBgYGBoYnNcbiAgPHRhYmxlLmJvZHkgYXMgfGJvZHkgcGVyc29uIGluZGV4fD5cbiAgICA8Ym9keS5yb3cgYXMgfHJvd3w-XG4gICAgICA8cm93LmNlbGw-XG4gICAgICAgIHt7cGVyc29uLmZpcnN0TmFtZX19ICN7e2luZGV4fX1cbiAgICAgIDwvcm93LmNlbGw-XG4gICAgICA8cm93LmNlbGw-XG4gICAgICAgIHt7cGVyc29uLmxhc3ROYW1lfX1cbiAgICAgIDwvcm93LmNlbGw-XG4gICAgICA8cm93LmNlbGw-XG4gICAgICAgIHt7cGVyc29uLnBvaW50c319XG4gICAgICA8L3Jvdy5jZWxsPlxuICAgIDwvYm9keS5yb3c-XG4gIDwvdGFibGUuYm9keT5cbiAgYGBgXG4gIEl0IGNhbiBhbHNvIGJlIHVzZWQgYXMgYSBibG9ja2xlc3MgY29tcG9uZW50IHRvIGxldCB5ZXRpIHRhYmxlIGF1dG9tYXRpY2FsbHlcbiAgdW5yb2xsIHRoZWUgcm93cyBmb3IgeW91LCBiYXNlZCBvbiB0aGUgYEBwcm9wYCBhcmd1bWVudHMgeW91IHBhc3NlZCBpbiB0byB0aGVcbiAgY29sdW1uIGRlZmluaXRpb24gY29tcG9uZW50cy5cbiAgYGBgaGJzXG4gIDx0YWJsZS5ib2R5Lz5cbiAgYGBgXG4gIFJlbWVtYmVyIHRoYXQgdGhpcyBjb21wb25lbnQncyBibG9jayB3aWxsIGJlIHJlbmRlcmVkIG9uY2UgcGVyIGVhY2ggaXRlbSBpbiB0aGUgYEBkYXRhYCBhcnJheS5cblxuICBAY2xhc3MgQm9keVxuICBAeWllbGQge29iamVjdH0gYm9keVxuICBAeWllbGQge0NvbXBvbmVudH0gYm9keS5yb3cgLSB0aGUgcm93IGNvbXBvbmVudFxuICBAeWllbGQge09iamVjdH0gcm93RGF0YSAtIG9uZSBpdGVtIGluIHRoZSBkYXRhIGFycmF5XG4gIEB5aWVsZCB7bnVtYmVyfSBpbmRleFxuKi9cblxuLy8gdGVtcGxhdGUgaW1wb3J0c1xuaW1wb3J0IHsgZm4sIGdldCwgaGFzaCB9IGZyb20gJ0BlbWJlci9oZWxwZXInO1xuaW1wb3J0IFRCb2R5Um93IGZyb20gJy4vdGJvZHkvcm93Lmdqcyc7XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIEJvZHkgZXh0ZW5kcyBDb21wb25lbnQge1xuICA8dGVtcGxhdGU-XG4gICAgPHRib2R5IGNsYXNzPXt7QHRoZW1lLnRib2R5fX0gLi4uYXR0cmlidXRlcz5cbiAgICAgIHt7I2lmIChoYXMtYmxvY2spfX1cblxuICAgICAgICB7eyNlYWNoIEBkYXRhIGFzIHxyb3dEYXRhIGluZGV4fH19XG4gICAgICAgICAge3t5aWVsZCAoaGFzaCByb3c9KGNvbXBvbmVudCBUQm9keVJvdyB0aGVtZT1AdGhlbWUgb25DbGljaz1Ab25Sb3dDbGljayBjb2x1bW5zPUBjb2x1bW5zKSkgcm93RGF0YSBpbmRleH19XG4gICAgICAgIHt7L2VhY2h9fVxuXG4gICAgICB7e2Vsc2V9fVxuXG4gICAgICAgIHt7I2VhY2ggQGRhdGEgYXMgfHJvd0RhdGF8fX1cbiAgICAgICAgICA8VEJvZHlSb3dcbiAgICAgICAgICAgIEB0aGVtZT17e0B0aGVtZX19XG4gICAgICAgICAgICBAb25DbGljaz17e2lmIEBvblJvd0NsaWNrIChmbiB0aGlzLmhhbmRsZVJvd0NsaWNrIHJvd0RhdGEpfX1cbiAgICAgICAgICAgIEBjb2x1bW5zPXt7QGNvbHVtbnN9fVxuICAgICAgICAgICAgYXMgfHJvd3xcbiAgICAgICAgICA-XG5cbiAgICAgICAgICAgIHt7I2VhY2ggQGNvbHVtbnMgYXMgfGNvbHVtbnx9fVxuICAgICAgICAgICAgICA8cm93LmNlbGwgQGNsYXNzPXt7Y29sdW1uLmNvbHVtbkNsYXNzfX0-XG4gICAgICAgICAgICAgICAge3sjaWYgY29sdW1uLnByb3B9fVxuICAgICAgICAgICAgICAgICAge3tnZXQgcm93RGF0YSBjb2x1bW4ucHJvcH19XG4gICAgICAgICAgICAgICAge3tlbHNlfX1cbiAgICAgICAgICAgICAgICAgIHt7cm93RGF0YX19XG4gICAgICAgICAgICAgICAge3svaWZ9fVxuICAgICAgICAgICAgICA8L3Jvdy5jZWxsPlxuICAgICAgICAgICAge3svZWFjaH19XG4gICAgICAgICAgPC9UQm9keVJvdz5cbiAgICAgICAge3svZWFjaH19XG4gICAgICB7ey9pZn19XG4gICAgPC90Ym9keT5cbiAgPC90ZW1wbGF0ZT5cbiAgLyoqXG4gICAqIEFkZHMgYSBjbGljayBhY3Rpb24gdG8gZWFjaCByb3csIGNhbGxlZCB3aXRoIHRoZSBjbGlja2VkIHJvdydzIGRhdGEgYXMgYW4gYXJndW1lbnQuXG4gICAqIENhbiBiZSB1c2VkIHdpdGggYm90aCB0aGUgYmxvY2tsZXNzIGFuZCBibG9jayBpbnZvY2F0aW9ucy5cbiAgICpcbiAgICogQGFyZ3VtZW50IG9uUm93Q2xpY2tcbiAgICogQHR5cGUgRnVuY3Rpb25cbiAgICovXG5cbiAgQGFjdGlvblxuICBoYW5kbGVSb3dDbGljayhyb3dEYXRhKSB7XG4gICAgdGhpcy5hcmdzLm9uUm93Q2xpY2s_Lihyb3dEYXRhKTtcbiAgfVxufVxuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxTQUFTLE1BQU0sUUFBUSxnQkFBZ0I7QUFFdkMsT0FBTyxlQUFlLHFCQUFxQjtBQUUzQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBOEJBLEdBRUEsbUJBQW1CO0FBQ25CLFNBQVMsRUFBRSxFQUFFLEdBQUcsRUFBRSxJQUFJLFFBQVEsZ0JBQWdCO0FBQzlDLE9BQU8sY0FBYyxrQkFBa0I7QUFFdkMsZUFBZSxNQUFNLGFBQWE7SUFDaEMsTUFBQTtRQUFBLDBDQUFVLENBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7RUErQlYsQ0FBQSxFQUFBO1lBQUEsV0FBQSxJQUFXO1lBQVg7Z0JBQUEsT0FBQSxLQUFBLFNBQUEsQ0FBQSxFQUFXO1lBQUQ7UUFBQTtJQUFBLENBL0JBO0lBZ0NWOzs7Ozs7R0FNQyxHQUVELENBQUM7SUFDRCxlQUFlLE9BQU8sRUFBRTtRQUN0QixJQUFJLENBQUMsSUFBSSxDQUFDLFVBQVUsR0FBRztJQUN6QjtBQUNGIn0